<ng2-dropdown [dynamicUpdate]="dynamicUpdate">
  <ng2-dropdown-menu [focusFirstElement]="focusFirstElement"
    [zIndex]="zIndex"
    [appendToBody]="appendToBody"
    [offset]="offset">
    @for (item of items; track item; let index = $index; let last = $last) {
      <ng2-menu-item
        [value]="item"
        >
        @switch (!!templates.length) {
          @case (false) {
            <span
              [innerHTML]="item[displayBy] | highlight : tagInput.inputForm.value.value">
            </span>
          }
          @default {
            <ng-template
              [ngTemplateOutlet]="templates.first"
              [ngTemplateOutletContext]="{ item: item, index: index, last: last }">
            </ng-template>
          }
        }
      </ng2-menu-item>
    }
  </ng2-dropdown-menu>
</ng2-dropdown>
